import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getTopMarks(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/models/getTopMarks",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMarksNew(Redis, sectionId, reset) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/models/getMarksNew?sectionId=${sectionId}`,
      reset,
    );
  },
});
